@if (showField$ | async) {
  <mat-form-field>
    @if (field.label) {
      <mat-label>{{field.label}}</mat-label>
    }
    <textarea matInput
      [required]="!!field.validators?.required"
      [attr.rows]="field.attrs.rows || 3"
      [attr.type]="field.type"
      [attr.name]="field.name"
      [attr.maxlength]="field.attrs.maxlength || field.attrs.maxLength || null"
      [placeholder]="field.placeholder | translate"
    [formControl]="$any(field.control)"></textarea>
    @if (hasDanger()) {
      <mat-hint [ngStyle]="{'color': 'red'}" align="start">{{errorText()}}</mat-hint>
    }
    @if (field.help && !hasDanger()) {
      <mat-hint align="start">{{field.help | translate}}</mat-hint>
    }
  </mat-form-field>
}
